import { useAuthStore } from '@/stores/auth'
import { authApi } from '@/api/auth'
import { getLoginRoute } from '@/utils/router'

export const requireAuth = async (to, from, next) => {
  const authStore = useAuthStore()
  
  if (!authStore.isAuthenticated) {
    const loginRoute = getLoginRoute(null, to)
    next({ name: loginRoute, query: { redirect: to.fullPath } })
    return
  }

  // Verify token is still valid by fetching user
  // This acts as a token refresh/validation check
  try {
    const response = await authApi.me()
    authStore.setAuth(response.data.user, authStore.token)
    next()
  } catch (error) {
    // Token is invalid, clear auth and redirect to login
    authStore.clearAuth()
    const loginRoute = getLoginRoute(null, to)
    next({ name: loginRoute, query: { redirect: to.fullPath } })
  }
}

export const requireRole = (...roles) => {
  return async (to, from, next) => {
    const authStore = useAuthStore()
    
    if (!authStore.isAuthenticated) {
      const loginRoute = getLoginRoute(null, to)
      next({ name: loginRoute, query: { redirect: to.fullPath } })
      return
    }

    // Verify token and refresh user data
    try {
      const response = await authApi.me()
      authStore.setAuth(response.data.user, authStore.token)
      
      if (!authStore.hasAnyRole(roles)) {
        next({ name: 'dashboard' }) // Redirect to dashboard if no permission
      } else {
        next()
      }
    } catch (error) {
      // Token is invalid, clear auth and redirect to login
      authStore.clearAuth()
      const loginRoute = getLoginRoute(null, to)
      next({ name: loginRoute, query: { redirect: to.fullPath } })
    }
  }
}

export const requireGuest = (to, from, next) => {
  const authStore = useAuthStore()
  
  if (authStore.isAuthenticated) {
    next({ name: 'dashboard' })
  } else {
    next()
  }
}

